var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-primary",attrs:{"loading":_vm.loading},on:{"click":_vm.silentLogin}},[_vm._v(" Silent Login ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }